module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/your_project_en-51270133c1ed6743d03ad5b67772a628.png";